import { CommonModule } from '@angular/common';
import { Component, inject, Inject, Optional, signal, WritableSignal } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { InputDropdownConfig } from '@app/_interfaces/generic.interface';
import { CustomBottomSheetRef } from '@app/_services/custom-bottom-sheet.service';
import { SettingsService } from '@app/_services/settings.service';
import { SvgComponent } from '@app/components/shared/svg/svg.component';
import { InputDropdownComponent } from '@app/components/shared/inputs/input-dropdown/input-dropdown.component';
import { CacheService } from '@app/_services/cache.service';
import { GalleryGroupByMode } from '../attachment/attachment.component';

@Component({
  selector: 'app-gallery-view',
  imports: [
    CommonModule,
    SvgComponent,
    InputDropdownComponent,
  ],
  templateUrl: './gallery-view.component.html',
  styleUrl: './gallery-view.component.scss'
})
export class GalleryViewComponent {

  /** Group by signal — bound to the parent's signal via data injection */
  groupBy: WritableSignal<GalleryGroupByMode>;

  groupByConfig: Record<string, InputDropdownConfig> = {
    entityTitle: { name: 'Feature' },
    month: { name: '' },
    none: { name: '' },
  };

  constructor(
    public ss: SettingsService,
    @Optional() public dialogRef: MatDialogRef<GalleryViewComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public dialogData: { groupBy: WritableSignal<GalleryGroupByMode> },
    @Optional() public bottomSheetRef: CustomBottomSheetRef<GalleryViewComponent>,
    @Optional() @Inject(MAT_BOTTOM_SHEET_DATA) public bottomSheetData: { groupBy: WritableSignal<GalleryGroupByMode> },
    public cc: CacheService
  ) {
    const data = (dialogData || bottomSheetData)!;
    this.groupBy = data.groupBy;

    // Set translated names
    const texts = this.ss.texts();
    this.groupByConfig['month'].name = texts['common_monthly'] || 'Monthly';
    this.groupByConfig['none'].name = texts['common_none'] || 'None';

    dialogRef?.backdropClick().subscribe(() => this.closeDialog());
    bottomSheetRef?.backdropClick().subscribe(() => this.closeDialog());
  }

  onGroupByChange() {
    // Persist to viewSettings
    const viewSignals = this.ss.viewSignals();
    viewSignals['galleryGroupBy'].set(this.groupBy());
    this.ss.updateViewSettings();
  }

  closeDialog() {
    if (this.dialogRef) {
      this.dialogRef.close();
    } else if (this.bottomSheetRef) {
      this.bottomSheetRef.dismiss();
    }
  }
}
